import styled from "@emotion/styled";

export const LargePDFModalWrapper = styled.div(({ theme }) => ({
	maxWidth: "400px",
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	gap: "16px",
	p: {
		...theme.project.typography.body.body1,
		margin: 0
	},
	"button:first-of-type": {
		textDecoration: "underline",
		fontSize: "16px",
		svg: {
			marginLeft: "4px"
		}
	}
}));
